import React, { useState, useRef, useEffect } from 'react'
import gsap from 'gsap'
import PropTypes from 'prop-types'

// Hooks
import { useScrolledAnimation } from '../animation/useScrolledAnimation'

// Components
import Grid from '../Grid'
import GridItem from '../GridItem'

// Vars
import { Title } from '../../styles/vars/textStyles.style'

// Styles
import {
  AccordionItem,
  AccordionInner,
  AccordionItemLine,
  Details,
  AccordionTitle,
  DescOuter,
  Desc,
  Toggle,
} from './index.style'
import RichTextPlain from '../RichTextPlain'

const Item = ({ id, linkId, title, content, beginOpen }) => {
  const [isOpen, setIsOpen] = useState(beginOpen),
    [maxHeight, setMaxHeight] = useState(0)

  const descriptionInner = useRef(null)

  useEffect(() => {
    descriptionInner.current &&
      setMaxHeight(isOpen ? descriptionInner.current.offsetHeight * 1.2 : 0)

    setTimeout(window.scroll.update, 750)
  }, [isOpen, descriptionInner])

  const innerRef = useRef(),
    toggleRef = useRef(),
    lineRef = useRef(),
    itemIn = useRef()

  useScrolledAnimation({
    id: id,
    transition: itemIn,
    sync: false,
    useInView: true,
  })

  useEffect(() => {
    if (!innerRef.current || !toggleRef.current || !lineRef.current) return

    itemIn.current = gsap.timeline({
      paused: true,
      defaults: {
        duration: 1.5,
        ease: 'power2.out',
      },
    })

    itemIn.current.fromTo(
      innerRef.current,
      {
        opacity: 0,
        x: 50,
      },
      {
        opacity: 1,
        x: 0,
      },
      0
    )

    itemIn.current.fromTo(
      toggleRef.current,
      {
        opacity: 0,
      },
      {
        duration: 1,
        opacity: 1,
      },
      0.5
    )

    itemIn.current.fromTo(
      lineRef.current,
      {
        scaleX: 0,
      },
      {
        scaleX: 1,
        ease: 'power2.inOut',
      },
      0
    )
  }, [innerRef, toggleRef, lineRef])

  return (
    <AccordionItem
      id={linkId}
      isOpen={isOpen}
      onClick={() => setIsOpen(!isOpen)}
      data-scroll
      data-scroll-id={id}
    >
      <AccordionInner ref={innerRef}>
        <Grid>
          <GridItem tiny={10}>
            <Details>
              <AccordionTitle>
                <Title>{title}</Title>
              </AccordionTitle>
            </Details>
          </GridItem>
          <GridItem tiny={2} tinyStart={11} tabletL={1} tabletLStart={12}>
            <Details toggle>
              <Toggle ref={toggleRef} isOpen={isOpen} />
            </Details>
          </GridItem>
          <GridItem desk={11}>
            <DescOuter maxHeight={maxHeight}>
              <Desc ref={descriptionInner}>
                <RichTextPlain id={`${id}-description`} content={content} />
              </Desc>
            </DescOuter>
          </GridItem>
        </Grid>
      </AccordionInner>
      <AccordionItemLine ref={lineRef} />
    </AccordionItem>
  )
}

Item.propTypes = {
  id: PropTypes.string.isRequired,
  linkId: PropTypes.string.isRequired,
  title: PropTypes.string,
  content: PropTypes.object,
  beginOpen: PropTypes.bool,
}

export default Item
